export * from "./Typography"
export { default } from "./Typography"
